<template>
  <proctoring-gate :inner="testComponent" />
</template>

<script>
import ProctoringGate from "../../components/ProctoringGate.vue";
import CertificatedTest from "./CertificatedTest.vue";

export default {
  name: "ProctoredCertificatedTest",
  components: { ProctoringGate },
  computed: {
    testComponent() {
      return CertificatedTest;
    },
  },
};
</script>
